import request from '@/utils/request'


// 查询赛事管理列表
export function listCompetitionManage(query) {
  return request({
    url: '/platform/competition-manage/list',
    method: 'get',
    params: query
  })
}

// 查询赛事管理分页
export function pageCompetitionManage(query) {
  return request({
    url: '/platform/competition-manage/page',
    method: 'get',
    params: query
  })
}

// 查询赛事管理详细
export function getCompetitionManage(data) {
  return request({
    url: '/platform/competition-manage/detail',
    method: 'get',
    params: data
  })
}

// 新增赛事管理
export function addCompetitionManage(data) {
  return request({
    url: '/platform/competition-manage/add',
    method: 'post',
    data: data
  })
}

// 修改赛事管理
export function updateCompetitionManage(data) {
  return request({
    url: '/platform/competition-manage/edit',
    method: 'post',
    data: data
  })
}

// 删除赛事管理
export function delCompetitionManage(data) {
  return request({
    url: '/platform/competition-manage/delete',
    method: 'post',
    data: data
  })
}
